module.exports = __webpack_public_path__ + "static/img/celoscope-detail-26.02fee29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-26.jpg
// module id = QgIx
// module chunks = 51